/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Gymnasium_Riedberg2Inputs */

const en__field_enum_gymnasium_riedberg2 = /** @type {(inputs: _Field_Enum_Gymnasium_Riedberg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field_enum_gymnasium_riedberg2 = /** @type {(inputs: _Field_Enum_Gymnasium_Riedberg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gymnasium Riedberg`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field_Enum_Gymnasium_Riedberg2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_gymnasium_riedberg2 = /** @type {((inputs?: _Field_Enum_Gymnasium_Riedberg2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Gymnasium_Riedberg2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_gymnasium_riedberg2(inputs)
	return de__field_enum_gymnasium_riedberg2(inputs)
});
export { _field_enum_gymnasium_riedberg2 as "_field_enum_Gymnasium_Riedberg" }